import React from 'react';
import { Tag, TagLeftIcon, TagLabel, TagRightIcon } from '@chakra-ui/react';
import { FAIcon } from '../fa-icon/component.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';

var AttentionGrabber = function AttentionGrabber(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'generic' : _ref$type,
      grabberClick = _ref.grabberClick,
      label = _ref.label,
      icon = _ref.icon,
      iconClick = _ref.iconClick,
      className = _ref.className,
      rightIcon = _ref.rightIcon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size;
  return /*#__PURE__*/React.createElement(Tag, {
    variant: type,
    className: _formatClassName(['attention-grabber', "attention-grabber-".concat(type), {
      clickable: !!grabberClick
    }, className]),
    onClick: grabberClick,
    size: size
  }, !!icon && /*#__PURE__*/React.createElement(TagLeftIcon, {
    as: FAIcon,
    icon: icon,
    onClick: iconClick
  }), !!label && /*#__PURE__*/React.createElement(TagLabel, {
    className: "attention-grabber-label"
  }, label), !!rightIcon && /*#__PURE__*/React.createElement(TagRightIcon, {
    as: FAIcon,
    icon: rightIcon,
    onClick: iconClick
  }));
};

AttentionGrabber.displayName = "AttentionGrabber";
AttentionGrabber.displayName = 'AttentionGrabber';
export { AttentionGrabber };